import AWS from "aws-sdk";
import { getAWSCredentialsForCurrentUserSession } from "utils/aws";

/**
 * Copy an existing S3 object to another bucket/key
 * @param {Object} options
 * @param {string} options.sourceKey - The key of the existing file in the source bucket
 * @param {string} options.destinationKey - The new key for the copied file
 * @param {string} options.sourceBucket - Required: source S3 bucket name
 * @param {string} options.destinationBucket - Required: destination S3 bucket name
 */
export const copyS3Object = async ({
  sourceKey,
  destinationKey,
  sourceBucket,
  destinationBucket,
}) => {
  if (!sourceKey || !destinationKey || !sourceBucket || !destinationBucket) {
    throw new Error(
      "sourceKey, destinationKey, sourceBucket, and destinationBucket are all required"
    );
  }

  const credentials = await getAWSCredentialsForCurrentUserSession();

  const s3 = new AWS.S3({
    credentials,
    apiVersion: "2006-03-01",
  });

  const copyParams = {
    CopySource: `/${sourceBucket}/${encodeURIComponent(sourceKey)}`,
    Bucket: destinationBucket,
    Key: destinationKey,
    ACL: "authenticated-read",
  };

  return await s3.copyObject(copyParams).promise();
};
